import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../src/App.css";
import "../src/Admin.css";
import Layout from "../src/common/Layout";

//app

import Home from "./screens/mobile/pages/Home";
import NotFound from "./screens/mobile/pages/NotFound";
import MobileSignUp from "./screens/mobile/pages/sign/MobileSignUp";
import EmailSignUp from "./screens/mobile/pages/sign/EmailSignUp";
import GoogleCallback from "./screens/mobile/pages/sign/GoogleCallback";
import GoogleSignUp from "./screens/mobile/pages/sign/GoogleSignUp";
import SnsSignUp from "./screens/mobile/pages/sign/SnsSignUp";
import SignUpFail from "./screens/mobile/pages/sign/SignUpFail";
import HospitalInfo from "./screens/mobile/pages/hospitalinfo/infoHospital";
import HospitalList from "./screens/mobile/pages/hospitalinfo/listHospital";
import Navbar from "./screens/mobile/pages/Navbar";
import Setting from "./screens/mobile/pages/Setting";
import HealthInfo from "./screens/mobile/pages/healthInfo/HealthInfo";
import QuestionHealth from "./screens/mobile/pages/question/QuestionHealth";
import QuestionFood from "./screens/mobile/pages/question/QuestionFood";
import Result from "./screens/mobile/pages/question/Result";
import Alram from "./screens/mobile/pages/setting/Alarm";
import Account from "./screens/mobile/pages/setting/Account";
import Register from "./screens/mobile/pages/sign/Register";
import Recommend from "./screens/mobile/pages/recommend/Recommend";
import Guide from "./screens/mobile/pages/recommend/Guide";
import Recipe from "./screens/mobile/pages/recommend/Recipe";
import RecommendForShare from "./screens/mobile/pages/recommend/RecommendForShare";
import RecipeForShare from "./screens/mobile/pages/recommend/RecipeForShare";
import MyPage from "./screens/mobile/pages/mypage/MyPage";
import MyPosts from "./screens/mobile/pages/mypage/MyPosts";
import MyComments from "./screens/mobile/pages/mypage/MyComments";
import Like from "./screens/mobile/pages/mypage/Like";
import Dislike from "./screens/mobile/pages/mypage/Dislike";
import BookmarkMeal from "./screens/mobile/pages/mypage/BookmarkMeal";
import BookmarkRecipe from "./screens/mobile/pages/mypage/BookmarkRecipe";
import BookmarkedMealDetail from "./screens/mobile/pages/mypage/BookmarkedMealDetail";
import Record from "./screens/mobile/pages/meal/Record";
import Analysis from "./screens/mobile/pages/meal/Analysis";
import Report from "./screens/mobile/pages/meal/Report";
import RequestToAddFood from "./screens/mobile/pages/meal/RequestToAddFood";
import HospitalResister from "./screens/mobile/pages/setting/HospitalResister";
import Policy from "./screens/mobile/pages/setting/Policy";
import Source from "./screens/mobile/pages/setting/Source";
import Version from "./screens/mobile/pages/setting/Version";
import Profile from "./screens/mobile/pages/setting/account/Profile";
import Push from "./screens/mobile/pages/setting/Push";
import EditPass from "./screens/mobile/pages/setting/account/EditPass";
import Contact from "./screens/mobile/pages/setting/Contact";
import Resign from "./screens/mobile/pages/setting/account/Resign";
import Information from "./screens/mobile/pages/information/Information";
import InfoDetail from "./screens/mobile/pages/information/InfoDetail";
import InfoDetailForShare from "./screens/mobile/pages/information/InfoDetailForShare";
import InfoComments from "./screens/mobile/pages/information/InfoComments";
import CancerGpt from "./screens/mobile/pages/cancerGpt/CancerGpt";
import SymptomRecord from "./screens/mobile/pages/symptomRecord/SymptomRecord";
import DrugAlarm from "./screens/mobile/pages/DrugAlarm";
import Weight from "./screens/mobile/pages/Weight";
import Treatment from "./screens/mobile/pages/Treatment";
import Step from "./screens/mobile/pages/Step";
import Login from "./screens/mobile/pages/sign/Login";
import SignUp from "./screens/mobile/components/sign/SignUp";
import Bookmark from "./screens/mobile/pages/mypage/Bookmark";
import InfoDetailWithComment from "./screens/mobile/pages/information/InfoDetailWitComment";
import FindRecipe from "./screens/mobile/pages/recommend/FindRecipe";
import Event from "./screens/mobile/pages/Event";
import MyBlockUsers from "./screens/mobile/pages/mypage/MyBlockUsers";
import Dialog from "./screens/mobile/components/common/Dialog";

//admin
import Admin from "./screens/admin/pages/Admin";
import AdminSignin from "./screens/admin/pages/AdminSignIn";
import AdminSignUp from "./screens/admin/pages/AdminSignUp";
import AdminSighUp2 from "./screens/admin/pages/AdminSighUp2";
import AdminFindId from "./screens/admin/pages/FindId";
import AdminFindAdminPwd from "./screens/admin/pages/FindAdminPwd";
import AdminManagement from "./screens/admin/pages/Management";
import AdminContents from "./screens/admin/pages/Contents";
import AdminBoard from "./screens/admin/pages/Board/Board";
import AdminAccount from "./screens/admin/pages/Account";
import AdminManagementDetail from "./screens/admin/pages/ManagementDetail";
import AdminEditAdmin from "./screens/admin/pages/Account/EditAdmin";
import AdminMemberList from "./screens/admin/pages/Account/MemberList";
import AdminBoardId from "./screens/admin/pages/Board/BoardId";
import AdminCenterDetail from "./screens/admin/pages/Board/CenterDetail";
import AdminInformationDetail from "./screens/admin/pages/Board/InformationDetail";
import AdminHospital from "./screens/admin/pages/Hospital";
import AdminHospitalAdd from "./screens/admin/pages/Hospital/HospitalAdd";
import AdminHospitalId from "./screens/admin/pages/Hospital/HospitalId";
import AdminHospitalEdit from "./screens/admin/pages/Hospital/HospitalEdit";
import AdminAccountPrev from "./screens/admin/pages/Account/AccountPrev";
import AdminAccountApprov from "./screens/admin/pages/Account/AccountApprov";
import AdminMyAccount from "./screens/admin/pages/Account/MyAccount";
import UsageId from "./screens/mobile/pages/setting/contact/UsageId";
import Notice from "./screens/mobile/pages/setting/Notice";
import QuestionDisease from "./screens/mobile/pages/question/QuestionDisease";
import UsageQA from "./screens/mobile/pages/setting/contact/UsageQA";
import FindPass from "./screens/mobile/pages/sign/FindPass";
import ResetPassword from "./screens/mobile/pages/sign/ResetPassword";
import QuestionFoodAdd from "./screens/mobile/pages/question/QuestionFoodAdd";
import Funnels from "./screens/admin/pages/Funnels";

//landingpage
import Landing from "./screens/landingpage/Landing";
import MoveAppStore from "./screens/landingpage/MoveAppStore";
import MoveAppStoreForInsta from "./screens/landingpage/MoveAppStoreForInsta";
import DrugDiary from "./screens/landingpage/DrugDiary";

//태그 매니저
import TagManager from "react-gtm-module";

import TextEditor from "./screens/admin/pages/TextEditor";
import InfoSearch from "./screens/mobile/pages/information/InfoSearch";
import TestPage from "./screens/admin/pages/Board/TestPage";
import ExternalLink from "./screens/mobile/pages/community/ExternalLink";

// Firebase Messaging
import firebaseMessaging from "./utils/firebaseMessaging";
import { useDispatch } from "react-redux";
import { saveLoginInfo } from "./features/mobile/commonSlice";
import api from "./common/api";
import { storage } from "./utils/storage";
import { StatusBar, Style } from '@capacitor/status-bar';
import { App as CapacitorApp } from '@capacitor/app';

// Component to handle initial route based on login status
const InitialRoute = () => {
  const { loginInfo } = useSelector((state) => state.commonApp);

  // If user is logged in (via persisted Redux), redirect to home
  // Otherwise, redirect to sign in page
  if (loginInfo && loginInfo.userId) {
    return <Navigate to="/home" replace />;
  }

  return <Navigate to="/sign" replace />;
};

function App() {
  const { loginInfo } = useSelector((state) => state.commonApp);
  const [updateAlarm, setUpdateAlarm] = useState(false);
  const dispatch = useDispatch();

  const tagManagerArgs = {
    //태그 매니저
    gtmId: "GTM-N3XGGSS",
    // dataLayer: {
    //   event: "app",
    //   //user_id: firebaseToken || loginInfo.snsId || null,
    //   method: "login_method",
    //   page: "app",
    // },
    // dataLayerName: "dataLayer",
  };

  useEffect(() => {
    // Platform detection - add class to body for platform-specific styling
    const { Capacitor } = require('@capacitor/core');
    const platform = Capacitor.getPlatform();

    console.log('Platform detected:', platform);
    console.log('HTML classes before:', document.documentElement.className);

    // Add platform class to document root
    if (platform === 'android') {
      // Use direct className manipulation to avoid concatenation issues
      const currentClasses = document.documentElement.className;
      const classArray = currentClasses.split(' ').filter(c => c && !c.includes('platform-'));
      classArray.push('platform-android');
      document.documentElement.className = classArray.join(' ');

      // Inject Android-specific CSS with multiple selector variations to ensure it applies
      const styleId = 'android-safe-area-styles';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          /* Android Safe Area Overrides - Multiple selectors for maximum compatibility */
          .safe-area-top {
            padding-top: 24px !important;
          }

          .safe-area-mt-header {
            margin-top: 56px !important; /* Header content height only */
          }

          .safe-area-mt-header-exact {
            margin-top: 56px !important; /* Header content height only */
          }

          .safe-area-mt-header-minimal {
            margin-top: 56px !important; /* Header content height only */
          }

          .safe-area-top-header {
            top: 56px !important; /* Below header */
          }

          .safe-area-mt-header-tabs {
            margin-top: 151px !important; /* 80px header + 71px tabs */
          }

          .safe-area-mt-header-keywords {
            margin-top: 160px !important; /* 80px header + 80px keywords */
          }

          .safe-area-bottom {
            padding-bottom: 32px !important;
          }
        `;
        document.head.appendChild(style);
      }

      // Also directly apply styles to elements with safe-area classes after delays
      const applyStyles = () => {
        const safeAreaTop = document.querySelectorAll('.safe-area-top');
        const safeAreaMtHeader = document.querySelectorAll('.safe-area-mt-header');
        const safeAreaMtHeaderMinimal = document.querySelectorAll('.safe-area-mt-header-minimal');

        console.log('Applying Android styles:');
        console.log('- safe-area-top elements:', safeAreaTop.length);
        console.log('- safe-area-mt-header elements:', safeAreaMtHeader.length);
        console.log('- safe-area-mt-header-minimal elements:', safeAreaMtHeaderMinimal.length);

        safeAreaTop.forEach((el, index) => {
          el.style.paddingTop = '24px';
          console.log(`Applied paddingTop to safe-area-top[${index}]:`, el);
        });
        safeAreaMtHeader.forEach(el => {
          el.style.marginTop = '56px'; // Header content height only
        });
        document.querySelectorAll('.safe-area-mt-header-exact').forEach(el => {
          el.style.marginTop = '56px'; // Header content height only
        });
        safeAreaMtHeaderMinimal.forEach(el => {
          el.style.marginTop = '56px'; // Header content height only
        });
        document.querySelectorAll('.safe-area-top-header').forEach(el => {
          el.style.top = '56px'; // Position below header
        });
        document.querySelectorAll('.safe-area-mt-header-tabs').forEach(el => {
          el.style.marginTop = '151px'; // 80px header + 71px tabs (from original CSS: 127px - 56px = 71px)
        });
        document.querySelectorAll('.safe-area-mt-header-keywords').forEach(el => {
          el.style.marginTop = '160px'; // 80px header + 80px keywords
        });
        document.querySelectorAll('.safe-area-bottom').forEach(el => {
          el.style.paddingBottom = '32px';
        });
      };

      // Apply after multiple delays to catch dynamic content
      setTimeout(applyStyles, 100);
      setTimeout(applyStyles, 500);
      setTimeout(applyStyles, 1000);

      // Re-apply when navigating (using MutationObserver)
      const observer = new MutationObserver(() => {
        setTimeout(applyStyles, 50);
      });
      observer.observe(document.body, { childList: true, subtree: true });

      console.log('Android safe area styles injected and direct style manipulation enabled');

      // Configure Status Bar for Android
      const configureStatusBar = async () => {
        try {
          await StatusBar.setOverlaysWebView({ overlay: true });
          await StatusBar.setStyle({ style: Style.Light });
          await StatusBar.setBackgroundColor({ color: '#00000000' });
        } catch (error) {
          console.error('Failed to configure status bar:', error);
        }
      };

      configureStatusBar();

      // Handle Android back button
      const backButtonListener = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
        } else {
          CapacitorApp.exitApp();
        }
      });

      // Cleanup listener on unmount
      return () => {
        backButtonListener.remove();
      };
    } else if (platform === 'ios') {
      document.documentElement.classList.add('platform-ios');
      document.documentElement.classList.remove('platform-android');
    }

    TagManager.initialize(tagManagerArgs);
    TagManager.initialize({
      gtmId: "GTM-MHZ2ZXDV",
    });

    // Initialize Firebase Messaging
    const initFirebase = async () => {
      try {
        const token = await firebaseMessaging.initialize();
        if (token) {
          console.log('Firebase initialized with token:', token);
          // Send token to backend if user is logged in
          const userToken = localStorage.getItem('token');
          if (userToken) {
            await firebaseMessaging.sendTokenToBackend(token);
          }
        }
      } catch (error) {
        console.error('Failed to initialize Firebase:', error);
      }
    };

    initFirebase();

    // Auto-login functionality
    const attemptAutoLogin = async () => {
      const autoLoginEnabled = await storage.getItem('autoLogin');
      const autoLoginEmail = await storage.getItem('autoLoginEmail');
      const autoLoginPass = await storage.getItem('autoLoginPass');

      // Check if user is already logged in with valid session
      // If Redux has loginInfo AND accessToken exists, skip auto-login
      const accessToken = await storage.getItem('accessToken');
      if (loginInfo && loginInfo.userId && accessToken) {
        console.log('User already logged in with valid token, skipping auto-login');
        return;
      }

      // Only attempt auto-login if all credentials exist
      if (autoLoginEnabled === 'true' && autoLoginEmail && autoLoginPass) {
        try {
          console.log('Attempting auto-login...');
          const sessionToken = window.sessionStorage.getItem("token");

          const res = await api.post(`/auth/email/login`, {
            email: autoLoginEmail,
            password: autoLoginPass,
            firebaseToken: sessionToken,
          });

          if (res.data.ok) {
            console.log('Auto-login successful');

            // Store JWT token
            await storage.setItem('accessToken', res.data.accessToken);

            // Save login info to Redux
            dispatch(saveLoginInfo({ ...res.data, existPass: true }));

            // Navigate to home page using window.location
            window.location.href = '/home';
          } else {
            console.log('Auto-login failed:', res.data.error);
            // Clear invalid auto-login credentials
            await storage.removeItem('autoLogin');
            await storage.removeItem('autoLoginEmail');
            await storage.removeItem('autoLoginPass');
          }
        } catch (error) {
          console.error('Auto-login error:', error);
          // Clear invalid auto-login credentials
          await storage.removeItem('autoLogin');
          await storage.removeItem('autoLoginEmail');
          await storage.removeItem('autoLoginPass');
        }
      }
    };

    attemptAutoLogin();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const v3UpdateCheck = async () => {
      if (window?.flutter_inappwebview) {
        let appVersion = await window.flutter_inappwebview?.callHandler(
          "getIosVersion"
        );
        if (Number(appVersion.split(".")[2]) < 19) {
          setUpdateAlarm(true);
        }
      }
    };

    v3UpdateCheck();
  }, []);

  return (
    <BrowserRouter>
      {updateAlarm && (
        <Dialog
          innerClass={"p-4"}
          title={"App Update"}
          desc={"Please update to the latest version."}
          rightBtnTitle={"Update"}
          onRightBtnAction={MoveAppStore}
        />
      )}
      <ToastContainer />
      <Layout>
        <Routes>
          {/* app */}
          {/* 회원가입 로그인 */}
          <Route path="/sign" element={<SignUp />} />
          <Route path="/signup" element={<SignUp />} />

          <Route path="/mobile" element={<MobileSignUp />} />
          <Route path="/emailsignup" element={<EmailSignUp />} />
          <Route path="/auth/callback" element={<GoogleCallback />} />
          <Route path="/auth/google-signup" element={<GoogleSignUp />} />
          <Route path="/sns/:type" element={<SnsSignUp />} />
          <Route path="/fail/:type" element={<SignUpFail />} />
          {/* 자동로그인 또는 sns로그인 성공시 */}
          <Route path="/login" element={<Login />} />

          <Route path="/registered" element={<Register />} />
          <Route path="/findpass" element={<FindPass />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* 홈, 메뉴등 기본 */}
          <Route path="/home" element={<Home />} />
          <Route path="/nav" element={<Navbar />} />
          {/* 설문 */}
          <Route path="/question/health" element={<QuestionHealth />} />
          <Route path="/question/food" element={<QuestionFood />} />
          <Route path="/question/disease" element={<QuestionDisease />} />
          <Route path="/question/foodadd" element={<QuestionFoodAdd />} />
          <Route path="/result" element={<Result />} />
          {/* 계정 */}
          <Route path="/setting" element={<Setting />} />
          <Route path="/account" element={<Account />} />
          <Route path="/account/profile" element={<Profile />} />
          <Route path="/hospital/register" element={<HospitalResister />} />
          <Route path="/account/editpass" element={<EditPass />} />
          <Route path="/alarm" element={<Alram />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/source" element={<Source />} />
          <Route path="/version" element={<Version />} />
          <Route path="/push" element={<Push />} />
          <Route path="/resign" element={<Resign />} />
          {/* 병원 정보 찾기 - DISABLED FOR INTERNATIONAL VERSION */}
          {/* <Route path="hospitalinfo" element={<HospitalInfo />} /> */}
          {/* <Route path="hospitalinfo/list" element={<HospitalList />} /> */}
          <Route path="/hospitalinfo" element={<Navigate to="/home" replace />} />
          <Route path="/hospitalinfo/*" element={<Navigate to="/home" replace />} />
          {/* 내 건강 정보 */}
          <Route path="/healthinfo" element={<HealthInfo />} />
          {/* 추천식단 */}
          <Route path="/recommend" element={<Recommend />} />
          <Route
            path="/recommend/share/:type"
            element={<RecommendForShare />}
          />
          <Route path="/recommend/guide" element={<Guide />} />
          <Route path="/recommend/recipe/:type" element={<Recipe />} />
          <Route
            path="/recommend/recipe/share/:type"
            element={<RecipeForShare />}
          />
          <Route path="/recommend/findrecipe" element={<FindRecipe />} />
          {/* 정보 - DISABLED FOR INTERNATIONAL VERSION, REDIRECT TO RECOMMEND (추천식단) */}
          {/* <Route path="/info" element={<Information />} /> */}
          {/* <Route path="/info/:id" element={<InfoDetail />} /> */}
          {/* <Route path="/info/share/:id" element={<InfoDetailForShare />} /> */}
          {/* <Route path="/info/comment/:id" element={<InfoComments />} /> */}
          {/* <Route path="/info/search" element={<InfoSearch />} /> */}
          <Route path="/info" element={<Navigate to="/recommend" replace />} />
          <Route path="/info/*" element={<Navigate to="/recommend" replace />} />
          {/* Cancer GPT */}
          <Route path="/cancergpt" element={<CancerGpt />} />
          {/* 마이페이지 */}
          <Route path="/mypage" element={<MyPage />} />
          <Route path="/mypage/posts" element={<MyPosts />} />
          <Route path="/mypage/bookmark" element={<Bookmark />} />
          <Route path="/mypage/comments" element={<MyComments />} />
          <Route path="/mypage/blockUsers" element={<MyBlockUsers />} />
          <Route
            path="/mypage/infocomment/:id"
            element={<InfoDetailWithComment />}
          />
          <Route path="/bookmark/recipe" element={<BookmarkRecipe />} />
          <Route path="/like" element={<Like />} />
          <Route path="/dislike" element={<Dislike />} />
          <Route
            path="/bookmark/meal/:type"
            element={<BookmarkedMealDetail />}
          />
          {/*식사기록*/}
          <Route path="/meal/record" element={<Record />} />
          <Route path="/meal/analysis/:type" element={<Analysis />} />
          <Route path="/meal/report" element={<Report />} />
          <Route path="/meal/request" element={<RequestToAddFood />} />
          {/* 증상기록 */}
          <Route path="/symptom/record" element={<SymptomRecord />} />
          {/* 체중기록 */}
          <Route path="/weight/record" element={<Weight />} />
          {/* 진료알림 */}
          <Route path="/treatment" element={<Treatment />} />
          {/* 복약알림 */}
          <Route path="/drugalarm" element={<DrugAlarm />} />
          {/* 걸음수 상세 */}
          <Route path="/step" element={<Step />} />

          {/* 기타 */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact/usageid" element={<UsageId />} />
          <Route path="/contact/usageqa" element={<UsageQA />} />
          <Route path="/notice" element={<Notice />} />

          {/* admin */}
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/management" element={<AdminManagement />} />
          <Route
            path="/admin/management/detail/:type"
            element={<AdminManagementDetail />}
          />
          <Route path="/admin/contents" element={<AdminContents />} />
          <Route path="/admin/board" element={<AdminBoard />} />
          <Route path="/admin/boardid" element={<AdminBoardId />} />
          <Route
            path="/admin/customercenter/detail"
            element={<AdminCenterDetail />}
          />
          <Route
            path="/admin/information/detail"
            element={<AdminInformationDetail />}
          />
          <Route path="/admin/account" element={<AdminAccount />} />
          <Route
            path="/admin/account/prevapprov"
            element={<AdminAccountPrev />}
          />
          <Route
            path="/admin/account/approv"
            element={<AdminAccountApprov />}
          />
          <Route path="/admin/account/editadmin" element={<AdminEditAdmin />} />
          <Route path="/admin/account/myaccount" element={<AdminMyAccount />} />
          <Route
            path="/admin/account/memberlist"
            element={<AdminMemberList />}
          />
          <Route path="/admin/signin" element={<AdminSignin />} />
          <Route path="/admin/signup" element={<AdminSignUp />} />
          <Route path="/admin/signup2" element={<AdminSighUp2 />} />
          <Route path="/admin/findid" element={<AdminFindId />} />
          <Route path="/admin/findadminpwd" element={<AdminFindAdminPwd />} />
          <Route path="/admin/hospital" element={<AdminHospital />} />
          <Route path="/admin/hospital/add" element={<AdminHospitalAdd />} />
          <Route path="/admin/hospitalid" element={<AdminHospitalId />} />
          <Route path="/admin/hospital/edit" element={<AdminHospitalEdit />} />
          <Route path="/admin/funnels" element={<Funnels />} />
          {/* for test */}
          <Route path="/admin/text" element={<TextEditor />} />
          <Route path="/admin/test" element={<TestPage />} />
          {/* 랜딩페이지 */}
          <Route path="/landing/:type" element={<Landing />} />
          <Route path="/landing" element={<Landing />} />
          <Route path="/appdownload" element={<MoveAppStore />} />
          <Route path="/appdownloadisad" element={<MoveAppStoreForInsta />} />
          {/* 복약일기 큐알 구글플레이/앱스토어 이동 페이지 */}
          <Route path="/drugdiary" element={<DrugDiary />} />
          {/* 이벤트 페이지 */}
          {new Date() >= new Date("2023-09-11 00:00:00") &&
          new Date() < new Date("2023-10-16 00:00:00") ? (
            <Route path="event" element={<Event />} />
          ) : null}
          {/* 공통 */}
          <Route path="/" element={<InitialRoute />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* </Suspense> */}
      </Layout>
    </BrowserRouter>
  );
}

export default App;
